import api from '../api/axios';

class SponsorService {
    // Public — used by landing page & navbar
    static async getBrandPartnership() {
        const response = await api.get('/settings/brand-partnership');
        return response.data;
    }

    // Admin — get full settings + all ad spots
    static async getAdminSettings() {
        const response = await api.get('/settings/brand-partnership/fetch');
        return response.data;
    }

    // Admin — update toggle + official partner info
    static async updateSettings(data) {
        const response = await api.post('/settings/brand-partnership/update', data);
        return response.data;
    }

    // Admin — create ad spot
    static async createAdSpot(data) {
        const response = await api.post('/settings/brand-partnership/ad-spots', data);
        return response.data;
    }

    // Admin — update ad spot
    static async updateAdSpot(id, data) {
        const response = await api.put(`/settings/brand-partnership/ad-spots/${id}`, data);
        return response.data;
    }

    // Admin — delete ad spot
    static async deleteAdSpot(id) {
        const response = await api.delete(`/settings/brand-partnership/ad-spots/${id}`);
        return response.data;
    }
}

export default SponsorService;
